import { createContext, Dispatch } from "react";
import {
  DEFAULT_VISITOR_CONTEXT,
  TVisitorContext,
} from "src/trackers/viewerContext";

import { PublicationShortname } from "./auth/serviceIdentifier";
import { TAction } from "./reducer";

const CONTEXT_PERSISTANCE_KEY = "EPAPER_CONTEXT";

export type TAppContext = {
  pubId: PublicationShortname;
  issueId?: number;
  visitorContext: TVisitorContext | null;
  dispatch: Dispatch<TAction>;
};

const defaultInitialState: TAppContext = {
  pubId: PublicationShortname.DEFAULT,
  issueId: undefined,
  visitorContext: DEFAULT_VISITOR_CONTEXT,
  dispatch: () => null,
};

// Always return defaultInitialState for the initial render to avoid
// hydration mismatch (server renders "default", client must match).
// Persisted state is restored in AppContextHOC via useEffect after hydration.
export function getInitialState(): TAppContext {
  return defaultInitialState;
}

export function getPersistedState(): TAppContext | null {
  if (typeof window === "undefined") return null;
  const persistance = localStorage.getItem(CONTEXT_PERSISTANCE_KEY);
  return persistance ? (JSON.parse(persistance) as TAppContext) : null;
}

export function persistToStorage(state: TAppContext) {
  if (typeof window !== "undefined") {
    localStorage.setItem(
      CONTEXT_PERSISTANCE_KEY,
      JSON.stringify(state),
    );
  }
}

const AppContext = createContext<TAppContext>(getInitialState());

export default AppContext;
